// Legenda.jsx
import React from "react";
import "../styles/portal/Legenda.css";
import { colorForGeneric, colorForTaxaAplicada } from "./colorUtils";

function Legenda({ tipo, min, max, maxAplicado }) {
  const steps = [];

  if (tipo === "generic") {
    // valores amostrados para mostrar a escala
    const valores = (min === max) 
      ? [min] 
      : [min, (min + max) / 2, max];
    for (let v of valores) {
      steps.push({
        label: v.toFixed(2),
        color: colorForGeneric(v, min, max),
      });
    }
  }

  if (tipo === "taxa") {
    // escala fixa para ilustrar o conceito
    // console.log("LEGENDA: O min ´e =", min);
    const exemplos = [
      ...(min !== 0 ? [{ label: "0", value: 0 }] : []),
      ...(min !== 0 ? [{ label: `${min * 0.2}`, value: min * 0.2 }] : []),
      ...(min !== 0 ? [{ label: `${min * 0.5}`, value: min * 0.5 }] : []),// { label: `Abaixo (${min})`, value: min * 0.5 },
      { label: `${min}`, value: min },// { label: `Prescrito Min (${min})`, value: min },
      ...(min !== max ? [{ label: `${(min + max) / 2}`, value: (min + max) / 2 }] : []),// { label: "Intermediário", value: (min + max) / 2 },
      ...(min !== max ? [{ label: `${max}`, value: max }] : []),// { label: `Prescrito Max (${max})`, value: max },
      ...(maxAplicado > max ? [{ label: `${max + (maxAplicado - max) / 2}`, value: max + (maxAplicado - max) / 2 }] : []),// { label: "Acima", value: max + (maxAplicado - max) / 2 },
      ...(maxAplicado > max ? [{ label: `${maxAplicado}`, value: maxAplicado }] : []),// { label: `Máx aplicado (${maxAplicado})`, value: maxAplicado },
    ];
    for (let e of exemplos) {
      steps.push({
        label: e.label,
        color: colorForTaxaAplicada(e.value, min, max, maxAplicado, true),
      });
    }
  }

  return (
    <div className="legenda-container">
      <div className="legenda-tittle">Legenda</div>
      {steps.map((s, i) => (
        <div key={i} className="legenda-item">
          <div
            style={{
              width: 20,
              height: 20,
              backgroundColor: s.color,
              border: "1px solid #333",
              marginRight: 6,
            }}
            className="legenda-item-cor"
          ></div>
          <span className="legenda-item-descricao">{s.label}</span>
        </div>
      ))}
    </div>
  );
}

export default Legenda;
